import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import AboutTimeline from "../AboutTimeline";
import { useScroll, useTransform, useMotionValueEvent, easeInOut } from "motion/react";
import { useRef, useState } from "react";
import LettersPullUp from "../animations/LettersPullUp";
import CountUp from "../animations/CountUp";
import cx from "classnames";
import { AnimatedSectionsHeading } from "./AnimatedSectionsHeading";

export default function TimelineSection({ className }: { className?: string }) {
  const [hidden, setHidden] = useState(false);
  const container = useRef(null);

  const { scrollYProgress } = useScroll({ target: container, offset: ["start end", "end end"] }); // Progress of the about section filling the user's viewport
  const sceneStartTransition = useTransform(scrollYProgress, [0.3, 0.44], [0, 1], { ease: easeInOut });
  const yoeCountUp = useTransform(scrollYProgress, [0.38, 0.62], [0, 1], { ease: easeInOut });
  const timelineScene = useTransform(scrollYProgress, [0.195, 0.977], [0, 1]);

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    if (latest > 0.99) {
      setHidden(true);
      return;
    }

    setHidden(false);
  });

  return (
    <ScrollAnimContext.Provider value={scrollYProgress}>
      <div
        style={{ height: "500svh", marginTop: "-150svh" }}
        className={cx("w-full bg-black text-neutral-100", { "opacity-0": hidden })}
        ref={container}
      >
        <div style={{ height: "100svh" }} className='sticky top-0 flex flex-col justify-center items-center w-full'>
          <AnimatedSectionsHeading>
            {/* "refined over 8 years of building" title */}
            <div className='flex items-center justify-center relative flex-wrap'>
              <LettersPullUp scrollProgress={sceneStartTransition} text='building for ' length={33} />
              <LettersPullUp scrollProgress={sceneStartTransition} startingIndex={13} length={33}>
                <CountUp value={8} scrollProgress={yoeCountUp} />
              </LettersPullUp>
              <LettersPullUp scrollProgress={sceneStartTransition} text=' years and counting' startingIndex={14} length={33} />
            </div>
          </AnimatedSectionsHeading>
          <div className='absolute h-full w-full'>
            <ScrollAnimContext.Provider value={timelineScene}>
              <AboutTimeline />
            </ScrollAnimContext.Provider>
          </div>
        </div>
      </div>
    </ScrollAnimContext.Provider>
  );
}
